import React, { useRef, useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Toast } from 'primereact/toast';
import { useTranslation, Trans } from "react-i18next";
import "../../Styles/pages/settings.scss";
import PaySwitchActions from "../../Redux/transition/payswitch/payswitch.reducer";
import paystackKeyImage from "../../assets/images/paystack_keys.png"
import Loading from '../../Components/Loading';
import BusinessActions from "../../Redux/actions/business-actions"
import DocumentActions from '../../Redux/transition/document-upload/document-upload.reducer';
import { useFormik } from "formik";
import { CustomValidationMessage, CustomInfoMessage } from "../../Components/CustomMessage";
import { isCredentialOverlayLocked } from "../../utils/paymentProviderStatus";

const PROVIDER = "PAYSTACK";

function PaymentKeysSettingsPayStack({ onSave, credentialsUnlocked = false }) {

    const dispatch = useDispatch()
    const createCredentials = useCallback((businessId, credentials) => { dispatch(PaySwitchActions.paySwitchCredentialCreateRequest(businessId, credentials)) }, [dispatch]);
    const getBusiness = useCallback((businessId) => { dispatch(BusinessActions.businessRequest(businessId)) }, [dispatch])
    const getCredentials = useCallback((businessId, provider) => { dispatch(PaySwitchActions.paySwitchCredentialRequest(businessId, provider)) }, [dispatch]);
    const getVerificationRecord = useCallback((businessId) => { dispatch(DocumentActions.businessVerificationStatusRequest(businessId)) }, [dispatch]);

    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const paymentCredentials = useSelector((state) => state.payswitch.credentials);
    const fetchingPaymentCredentials = useSelector((state) => state.payswitch.fetchingCredentials);
    const creating = useSelector((state) => state.payswitch.creating);
    const credentials = useSelector((state) => state.payswitch.createdCredentials);
    const credentialsError = useSelector((state) => state.payswitch.errorCreatingCredentials);
    const business = useSelector((state) => state.businesses.business);
    const hasOwnCredentials = paymentCredentials?.provider === PROVIDER;
    const overlayLocked = isCredentialOverlayLocked(PROVIDER, business, credentialsUnlocked);

    const op = useRef(null);
    const op1 = useRef(null);
    const toast = useRef(null);
    const { t } = useTranslation("common");
    const [create, setCreate] = useState(false)
    const [save, setSave] = useState(false)
    const [editTokens, setEditTokens] = useState(false)
    const [toastShown, setToastShown] = useState(false)
    const [errorToastShown, setErrorToastShown] = useState(false)
    const isViewingSavedKey = hasOwnCredentials && !editTokens;
    const showEdit = hasOwnCredentials && !editTokens;
    const showCancel = hasOwnCredentials && editTokens && !toastShown;
    const showSave = (!hasOwnCredentials || editTokens) && !toastShown;

    const handleChange = (newValue) => {
        setSave(newValue);
        // Pass the updated state to the parent component when provided
        onSave?.(newValue);
    };

    const formik = useFormik({
        initialValues: {
            apiUser: "PAYSTACK",
            apiKey: "",
            merchantId: "100"
        },

        validate: (data) => {
            const errors = {};
            if (!(data.apiKey || "").trim()) {
                errors.apiKey = t("business.payment_apiKey_required");
            }
            return errors;
        },
        onSubmit: data => {
            createCredentials(defMembership.business.id, {
                apiUser: "PAYSTACK",
                apiKey: data.apiKey.trim(),
                merchantId: "100",
                provider: "PAYSTACK"
            })
            setErrorToastShown(false)
            setCreate(true)
        }
    })

    useEffect(() => {
        if (!create || creating) {
            return;
        }
        if (credentials) {
            setToastShown(true)
            setCreate(false);
            window.location.reload();
            return;
        }
        if (credentialsError) {
            setErrorToastShown(true)
            setCreate(false)
        }
    }, [create, creating, credentials, credentialsError]);

    return (

        <>{fetchingPaymentCredentials && !credentialsUnlocked ? <Loading /> :
            <div>
                <OverlayPanel ref={op} className="payment-keys-overlay">
                    <div>
                        <div className='mb-3 mt-2'>
                            <p className='instruction2-header mb-1'>{t("api_settings.paystack_teller2_heading")}</p>
                            <div>
                                <p className='instruction2 mb-1'>{t("api_settings.paystack_info1")}</p>

                                <div className='instruction2 mb-1'>
                                    <Trans i18nKey="api_settings.paystack_info2"
                                        components={{
                                            1: <span className='instruction2 mb-1'></span>,
                                            2: <span className='instruction1-inner'></span>,
                                            3: <span className='instruction2 mb-1'></span>
                                        }} />
                                </div>

                                <div>
                                    <Trans i18nKey="api_settings.paystack_info3"
                                        components={{
                                            1: <span className='instruction1 mb-1'></span>,
                                            2: <span className='instruction1-inner ml-1'></span>
                                        }} />
                                </div>

                                <div className="payment_teller_info4">
                                    <Trans i18nKey="api_settings.paystack_info4"
                                        components={{
                                            1: <span className='instruction1 mb-1'></span>,
                                            2: <span className='instruction1-inner ml-1'></span>,
                                            3: <span className='instruction1 mb-1'></span>,
                                            4: <span className='instruction1-inner ml-1'></span>,
                                            5: <span className='instruction1 mb-1'></span>,
                                        }} />
                                </div>

                                <p className='instruction2 mb-1'>{t("api_settings.paystack_info5")}</p>
                            </div>
                        </div>
                        <img src={paystackKeyImage} alt={t("business.payment_op1")} />
                    </div>
                </OverlayPanel>

                <OverlayPanel ref={op1} className="payment-keys-overlay">
                    <div>
                        <div className='mb-3 mt-2'>
                            <p className='instruction2-header mb-1'>{t("api_settings.paystack_teller2_heading")}</p>
                            <div>
                                <p className='instruction2 mb-1'>{t("api_settings.paystack_info1")}</p>

                                <div className='instruction2 mb-1'>
                                    <Trans i18nKey="api_settings.paystack_info2"
                                        components={{
                                            1: <span className='instruction2 mb-1'></span>,
                                            2: <span className='instruction1-inner'></span>,
                                            3: <span className='instruction2 mb-1'></span>
                                        }} />
                                </div>

                                <div>
                                    <Trans i18nKey="api_settings.paystack_info3"
                                        components={{
                                            1: <span className='instruction1 mb-1'></span>,
                                            2: <span className='instruction1-inner ml-1'></span>
                                        }} />
                                </div>

                                <div className="payment_teller_info4">
                                    <Trans i18nKey="api_settings.paystack_info4"
                                        components={{
                                            1: <span className='instruction1 mb-1'></span>,
                                            2: <span className='instruction1-inner ml-1'></span>,
                                            3: <span className='instruction1 mb-1'></span>,
                                            4: <span className='instruction1-inner ml-1'></span>,
                                            5: <span className='instruction1 mb-1'></span>,
                                        }} />
                                </div>

                                <p className='instruction2 mb-1'>{t("api_settings.paystack_info5")}</p>
                            </div>
                        </div>
                        <img src={paystackKeyImage} alt={t("business.payment_op2")} />
                    </div>
                </OverlayPanel>

                <Toast ref={toast} onRemove={(message) => {
                    if (message.severity === 'success') {
                        getCredentials(defMembership.business.id, "PAYSTACK");
                        getVerificationRecord(defMembership.business.id)
                        getBusiness(defMembership.business.id)
                        formik.resetForm()
                        handleChange(!save)
                    }
                }} />

                <div className="form-container">
                    <form onSubmit={formik.handleSubmit} className="wizard-forms-wrapper p-grid p-nogutter settings-edit-form">
                        <div className="card payment_card">
                            <div>
                                <div className='payment-credential'>{t("business.payment_credential")}</div>

                                <div className="grid api-div">
                                    <div className='hidden md:block col-2'>
                                    </div>
                                    <div className='col-12 md:col-8'>
                                        <div className='icon-main-div'><i className="pi pi-info-circle info-icon info-icon-i1"
                                            onClick={(e) => { op1.current.toggle(e) }}></i> <span className='payment_token'>{t("business.payment_token_info")}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid inputs-mb">
                                    <div className='col-12 md:col-2'>
                                        <label
                                            id="apiKey-label"
                                            htmlFor="apiKey"
                                            className={"label"}>
                                            {t("business.payment_apiKey_")}
                                            <span className="isterik">*</span>
                                        </label>
                                    </div>

                                    <div className='col-12 md:col-8 apiUser-div-width'>
                                        <InputText
                                            id="apiKey"
                                            name="apiKey"
                                            type='password'
                                            autoComplete="new-password"
                                            value={isViewingSavedKey ? "•••••••••" : (formik.values.apiKey || "")}
                                            onChange={(e) => {
                                                formik.setFieldValue("apiKey", e.target.value)
                                                if (errorToastShown) {
                                                    setErrorToastShown(false)
                                                }
                                            }}
                                            placeholder={t("business.payment_copy_paste_txt")}
                                            disabled={isViewingSavedKey || toastShown}
                                        />
                                    </div>

                                    {formik.errors.apiKey && (formik.touched.apiKey || formik.submitCount > 0) &&
                                        <CustomValidationMessage
                                            className='field_height'
                                            severity="error"
                                            text={t("business.payment_apiKey_required")} />
                                    }

                                    {showEdit && <div className='col-12 md:col-1 inner-edit'>
                                            <Button
                                                id='innerEdit-btn'
                                                label="Edit"
                                                type='button'
                                                text
                                                severity='info'
                                                onClick={() => {
                                                    setToastShown(false)
                                                    setErrorToastShown(false)
                                                    setEditTokens(true)
                                                    formik.setFieldValue("apiUser", "PAYSTACK")
                                                    formik.setFieldValue("apiKey", "")
                                                    formik.setErrors({})
                                                    formik.setTouched({})
                                                    handleChange(false)
                                                }}
                                                loading={creating}
                                            />
                                        </div>}
                                </div>
                            </div>
                        </div >

                        <div id="bottom_buttons_div">
                            <div className='cancel'>
                                {showCancel && <Button
                                        className="cancel-button p-button"
                                        id='edit_butto'
                                        label="Cancel"
                                        onClick={() => {
                                            setEditTokens(false)
                                            setToastShown(false)
                                            setErrorToastShown(false)
                                            formik.resetForm()
                                        }}
                                        type='button'
                                        loading={creating}
                                    />}
                            </div>

                            {toastShown &&
                                <CustomInfoMessage
                                    severity="success"
                                    summary=""
                                    detail={t("business.payment_success_info")}
                                />
                            }

                            {creating &&
                                <CustomInfoMessage
                                    severity="warn"
                                    summary=""
                                    detail={t("business.payment_progress_info")}
                                />
                            }

                            {(errorToastShown) &&
                                <CustomInfoMessage
                                    severity="error"
                                    summary=""
                                    detail={t("business.payment_error_info")}
                                />
                            }

                            <div>
                                {showSave &&
                                    <Button
                                        className="save-button p-button-info"
                                        id='edit_button'
                                        label="Save"
                                        type='submit'
                                        loading={creating}
                                    />}
                            </div>
                        </div>
                    </form >
                    <div id={overlayLocked ? "overlay" : undefined}>
                    </div>
                </div >
            </div >
        }
        </>
    )
}

export default PaymentKeysSettingsPayStack;